import React from 'react';
import { MessageSquare, Check } from 'lucide-react';

const WhatsAppConnectionModal = ({
  mobile,
  whatsAppNumber,
  setWhatsAppNumber,
  connectWhatsApp,
  skipWhatsApp
}) => {
  return (
    <div className="fixed inset-0 bg-gray-50 flex items-center justify-center p-3 overflow-y-auto" style={{ zIndex: 220 }}>
      <div className="bg-white w-full max-w-md rounded-2xl p-5 shadow-2xl my-auto">

        {/* Header */}
        <div className="text-center mb-4">
          <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
            <MessageSquare size={28} className="text-green-600" />
          </div>
          <h2 className="text-lg font-bold text-gray-800 mb-1">Connect WhatsApp</h2>
          <p className="text-sm text-gray-500">
            Get instant order updates and exclusive offers on WhatsApp
          </p>
        </div>

        {/* Benefits */}
        <div className="bg-green-50 border border-green-200 rounded-xl p-3 mb-4">
          <h3 className="font-semibold text-gray-800 mb-2 flex items-center gap-1.5 text-sm">
            <Check size={16} className="text-green-600" />
            Benefits of WhatsApp Updates
          </h3>
          <ul className="space-y-1 text-xs text-gray-700">
            {[
              'Real-time order and delivery notifications',
              'Exclusive deals and flash sales alerts',
              'Quick customer support via chat',
              'Subscription reminders and updates',
              'Easy reordering with one tap',
            ].map(item => (
              <li key={item} className="flex items-start gap-1.5">
                <span className="text-green-600 mt-0.5 flex-shrink-0">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Input */}
        <div className="mb-3">
          <label className="block text-xs font-semibold text-gray-700 mb-1.5">
            Enter WhatsApp Number
          </label>
          <div className="flex items-center border-2 border-gray-200 rounded-xl px-3 py-2.5 focus-within:border-green-500 transition-all">
            <span className="text-gray-600 font-medium mr-2 text-sm">+91</span>
            <input
              type="tel"
              inputMode="numeric"
              maxLength="10"
              value={whatsAppNumber}
              onChange={e => setWhatsAppNumber(e.target.value.replace(/\D/g, ''))}
              placeholder="Enter 10-digit number"
              className="flex-1 outline-none text-gray-800 text-base"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="space-y-2">
          <button
            onClick={connectWhatsApp}
            className="w-full bg-green-600 text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-green-700 transition-all text-sm"
          >
            <MessageSquare size={16} />
            Connect WhatsApp
          </button>
          <button
            onClick={skipWhatsApp}
            className="w-full bg-gray-100 text-gray-600 py-2.5 rounded-xl font-semibold hover:bg-gray-200 transition-all text-sm"
          >
            Skip for Now
          </button>
        </div>

        <p className="text-xs text-gray-400 text-center mt-2.5">
          You can enable this later from Settings
        </p>
      </div>
    </div>
  );
};

export default WhatsAppConnectionModal;
